import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterModule } from '@angular/router';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete-esb';
import { Address } from 'ngx-google-places-autocomplete-esb/lib/objects/address';

import { LocalisePipe } from '../../../../modules/pipes/localise.pipe';
import { DealService } from '../../../advance-application/services/deal.service';
import { DisableAutofillDirective } from '../../../shared/directives/disable-autofill.directive';
import { StatesService } from '../../../shared/services/states.service';
import { ParsedAddressInterface } from '../../../signup/models/parsed-address.interface';
import { InviteSignupProcessService } from '../../services/invite-signup-process.service';

@Component({
  selector: 'app-invite-signup-process-congratulations',
  templateUrl: './invite-signup-process-congratulations.component.html',
  styleUrls: ['./invite-signup-process-congratulations.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
    GooglePlaceModule,
    DisableAutofillDirective,
    LocalisePipe,
    FormsModule,
  ],
})
export class InviteSignupProcessCongratulationsComponent {
  public propertyAddress = '';
  private address = {
    lineAddress1: '',
    city: '',
    zip: '',
    state: '',
    country: '',
  };

  constructor(
    public inviteSignupProcessService: InviteSignupProcessService,
    public dealService: DealService,
    private statesService: StatesService,
    private router: Router,
  ) {}

  async next(): Promise<void> {
    this.inviteSignupProcessService.close.next();
    await this.router.navigate(['/apply'], {
      queryParams: this.address.lineAddress1
        ? this.address
        : {
            lineAddress1: this.propertyAddress,
          },
    });
  }

  public handleAddressChange(address: Address): void {
    if (!address.address_components) {
      return;
    }

    const parsedAddress: ParsedAddressInterface = {};

    address.address_components.forEach((v) => {
      v.types.forEach((t) => {
        if (t === 'administrative_area_level_1') {
          parsedAddress.state_abbr = v.short_name;
        }
        if (t === 'country') {
          parsedAddress.country_code = v.short_name;
        }
        parsedAddress[t as keyof ParsedAddressInterface] = v.long_name;
      });
    });

    if (
      this.statesService.usStatesList.includes(
        parsedAddress.state_abbr as string,
      )
    ) {
      this.address.state = parsedAddress.state_abbr || '';
    }
    this.address.lineAddress1 = `${parsedAddress.street_number || ''} ${
      parsedAddress.route || ''
    }`;
    this.address.city = parsedAddress.locality || '';
    this.address.zip = parsedAddress.postal_code || '';
    this.address.country = parsedAddress.country_code || '';
  }

  public setAutoFillOff(event: any): void {
    if (event) {
      event.target.attributes.autocomplete.value = Math.random()
        .toString(36)
        .slice(-6);
    }
  }
}
